import React from "react";
import { Box, Typography, Grid, Paper, Link } from "@mui/material";
import DownloadInNewTabLTP from "./downloadingFileLtp";
import AccessibilityRoundedIcon from '@mui/icons-material/AccessibilityRounded';
import { useHistory } from "react-router-dom";
import DownloadInNewTab from "./downloadingFile";

const DownloadDesignLTP = () => {
  const navigate = useHistory();
  return (
    <React.Fragment>
      <div
        className="design-pdf-download"
        style={{
          height: "100vh", // Full viewport height
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f5f5f5", // Optional background
          overflow:"hidden",
          position:'relative'
        }}
      >
        {/* Accessibility Icon */}
        <div
          style={{
            position: "absolute",
            top: 10, // Distance from the top of the viewport
            left: 10, // Distance from the left of the viewport
            display: "flex",
            alignItems: "center",

          }}
        >
          <AccessibilityRoundedIcon titleAccess="Accessibility" style={{ width: '50px', height: '50px' }} />
        </div>

          <Paper    style={{
            width: "70wh",
            height: "430px", // 80% of viewport height for content area
            maxWidth: 500,
            overflow: "auto",
          }}>
            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "space-around", p: 1, borderBottom: "1px solid #ccc" }}>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg"
                alt="emblem"
                loading="lazy"
                style={{ height: "60px", alignItems: 'center' }}
              />
              <img
                src="https://financialservices.gov.in/beta/themes/fds/images/120w_75_azadi.png"
                alt="amrit mahotsav"
                loading="lazy"
                style={{ height: "55px", alignItems: 'center' }}
              />
              <img
                src="https://financialservices.gov.in/beta/themes/fds/images/make-in-india-header.png"
                alt="digital"
                loading="lazy"
                style={{ height: "55px", alignItems: 'center' }}
              />
            </Box>

            {/* Department Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", p: 1, borderBottom: "1px solid #fff", color: "#fff", backgroundColor: '#012C46' }}>
              <Typography variant="h5" fontWeight="bold" textAlign="center" color="#fff" flex={1}>
                Housing and Urban Planning Department
                <br />
                <Typography variant="body2" color="#fff">
                  Government of Uttar Pradesh
                </Typography>
              </Typography>
            </Box>

            {/* Tip Section */}
            <Box sx={{ p: 1, backgroundColor: "#FFE082", margin: "10px" }}>
              <Typography variant="h6" color="purple" fontWeight="bold">
                Tip of the day
              </Typography>
              <ul>
                <li>Keep changing your password often and make them complex and not guessable.</li>
                <li>Document should only be downloaded from authentic platforms!</li>
              </ul>
            </Box>

            {/* Download Button */}
            <Box>
              <DownloadInNewTab/>
            </Box>

            {/* Footer Buttons */}
            <Grid container>
              <Grid item xs={6}>
                <Box sx={{ backgroundColor: "#0288D1", color: "#fff", p: 1, textAlign: "center", fontWeight: "bold",cursor:'pointer' }}>
                  Department User's <br />(<Link onClick={() => navigate.push("/digit-ui/employee/user/login")}>Login for Department</Link>)
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ backgroundColor: "#0288D1", color: "#fff", p: 1, textAlign: "center", fontWeight: "bold",cursor:'pointer'  }}>
                  Citizen User's <br />(<Link onClick={() => navigate.push("/digit-ui/citizen/login")}>Login For Citizen</Link>)
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </div>
    </React.Fragment>
  );
};

export default DownloadDesignLTP;
